module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0159.jpg?v=4dfbe32d";